import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Attach Bearer token as fallback if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ledger_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(", ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatUSD(n) {
  const num = Number(n) || 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    // Date-only (YYYY-MM-DD): format from the literal parts so the day never
    // shifts due to timezone differences. A donation dated 2026-06-01 must
    // always render as Jun 1 regardless of the viewer's UTC offset.
    const m = typeof iso === "string" && iso.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
    if (m) {
      const [, y, mo, d] = m;
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return `${months[Number(mo) - 1]} ${Number(d)}, ${y}`;
    }
    // Full ISO datetime — display in Pacific Time for consistency.
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "America/Los_Angeles" });
  } catch {
    return iso;
  }
}

// Returns today's date in America/Los_Angeles (Pacific Time) as YYYY-MM-DD.
// All date fields in the app should default to PT so a donation entered the
// evening of June 1 PT doesn't roll into June 2 UTC (or vice-versa).
export function todayISO() {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Los_Angeles",
    year: "numeric", month: "2-digit", day: "2-digit",
  });
  // en-CA always renders YYYY-MM-DD which is exactly what date inputs need.
  return fmt.format(new Date());
}
